import React from 'react'

const OffersMailIconWMO = ({height = "24", width = "25",viewBox="0 0 25 24"}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.08398 6.3418L11.7507 12.7335L20.4173 6.3418" stroke="#3E3E47" stroke-width="1.44445" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M19.3333 4.5H4.16667C2.97005 4.5 2 5.47005 2 6.66668V17.5001C2 18.6967 2.97005 19.6667 4.16667 19.6667H19.3333C20.53 19.6667 21.5 18.6967 21.5 17.5001V6.66668C21.5 5.47005 20.53 4.5 19.3333 4.5Z" stroke="#3E3E47" stroke-width="1.44445" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default OffersMailIconWMO
